import { EventTypes, track } from '@mc/track-event'
import type { CheckoutWarningClosedProps } from '../../types'

export const trackCheckoutWarningClosed = ({
  email,
  pageSource,
  message,
  messageCode,
  props,
}: CheckoutWarningClosedProps) => {
  track(EventTypes.FIELD_ENTRY_WARNING_CTA_CLICKED, {
    action: 'close_email_warning_message',
    page_source: pageSource,
    email,
    warning_data_code: messageCode,
    warning_data_message: message,
    warning_type: 'email',
    ...props,
  })
}
